import React, { Component, PropTypes } from 'react';
import { Menu, Button, Modal, Spin, Select, Radio, Alert, Input, Form } from 'antd';

import { browserHistory } from 'react-router';
import _ from 'lodash';
import Draft from 'draft-js';

import { connect } from 'react-redux';
import { getCategories } from 'data/category';
import { getContentProvinces, getContentDistricts, getContents } from 'data/content';
import { getClassById, getClassLogs, getReviewClass, rejectClassroom, approveClassroom, unrecommendClass, recommendClass, closeClass, getRevenueSummariesByClassId } from 'data/class';
import Utils from 'utils/utils';

import ClassHeader from './ClassHeader';
import ClassInfoTab from './ClassInfoTab';

import ClassReviewsTab from './ClassReviews';
import ClassOrders from './ClassOrders';
import ClassSchedules from './ClassSchedules';
import MasterScheduleTab from './MasterScheduleTab';

import classes from '../styles/class/ClassInfo.module.scss';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option, OptGroup } = Select;
const Confirm = Modal.confirm;

const TABS = [
  { label: 'Info', value: 'info' },
  { label: 'Schedules', value: 'schedules' },

  { label: 'Reviews', value: 'reviews' },
  { label: 'Master Schedule', value: 'master-schedule' },
];

class ClassInfo extends Component {
  constructor(props) {
    super(props);

    this.onRecommendClass = this.onRecommendClass.bind(this);
    this.onUnrecommendClass = this.onUnrecommendClass.bind(this);
    this.onChangeFocusTab = this.onChangeFocusTab.bind(this);
    this.showCloseConfirm = this.showCloseConfirm.bind(this);

    // props.getAutocompleteTeachers(props.classroom.owner.displayName);

    const rejectMessageEditorState = Draft.EditorState.createEmpty();
    if (browserHistory) {
      this.backListener = browserHistory.listen((location) => {
        if (location.action === 'POP') {
          this.setState({ selectedTab: location.query.selectedTab ? location.query.selectedTab : 'info' });
        }
      });
    }

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      showRejectModal: false,
      // fullDescriptionEditorState,
      // timetableEditorState,
      // preparingBeforeClassEditorState,
      // suitableForEditorState,
      // courseCoveringEditorState,

      categories: [],
      allSubcategories: [],

      rejectMessageEditorState,
      selectedTab: props.location.query.selectedTab ? props.location.query.selectedTab : 'info',
      loading: false,
    };
  }

  componentDidMount = async () => {
    const promises = [];

    const classId = this.props.params.classId;

    // classRevisions: state.classroom.classRevisions,
    // revenueSummaries: state.classroom.classRevenueSummaries,
    const results = await Promise.all([
      getClassById(classId),
      getCategories(classId, { limit: 20 }),
      getClassLogs(classId, { limit: 20 }),
      getReviewClass(classId, { limit: 20 }),
      getContentProvinces(),
      getContents('tags'),
      getRevenueSummariesByClassId(classId),
      getContentDistricts(),
    ]);
    const classroom = results[0];

    const categories = results[1];
    const classRevisions = results[2];
    const reviews = results[3];
    const provinces = results[4];
    const districts = results[7];
    const tags = results[5];
    const revenueSummaries = results[6];

    const allSubcategories = categories.reduce((result, cat) => _.concat(result, cat.subcategories), []);

    this.setState({
      categories,
      allSubcategories,
      reviews,
      classroom,
      classRevisions,
      provinces,
      revenueSummaries,
      tags,
      districts,
    });
    // promises.push(dispatch(getServiceFee()));
    // promises.push(dispatch(getCategories()));
    // promises.push(dispatch(getClassLogs(classId)));
    // promises.push(dispatch(getRevenueSummariesByClassId(classId)));

    // return Promise.all(promises);
  };

  componentWillUnmount() {
    this.backListener();
  }

  reloadClass = async (_id) => {
    this.setState({
      loading: true,
    });
    const classroom = await getClassById(_id);
    this.setState({
      classroom,
      loading: false,
    });
  };

  hideLoading = () => {
    this.setState({
      loading: false,
    });
  };
  showLoading = () => {
    this.setState({
      loading: true,
    });
  };

  onRecommendClass = async (_id) => {
    await recommendClass(_id);
    const classroom = await getClassById(_id);
    this.setState({
      classroom,
    });
  };

  onUnrecommendClass = async (_id) => {
    await unrecommendClass(_id);
    const classroom = await getClassById(_id);
    this.setState({
      classroom,
    });
  };

  onChangeFocusTab(tab) {
    this.setState({ selectedTab: tab.key });
    browserHistory.push(`${this.props.location.pathname}?selectedTab=${tab.key}`);
    window.scrollTo(0, 0);
  }

  showCloseConfirm() {
    Confirm({
      title: 'Do you Want to close this class?',
      // content: content || '',
      onOk: async () => {
        await closeClass(this.state.classroom._id);
        const classroom = await getClassById(this.state.classroom._id);
        this.setState({
          classroom,
        });
      },
      // onCancel: this.onCancel,
    });
  }

  renderTabs() {
    const classroom = this.state.classroom;
    let renderTabs = TABS.reduce((result, tab) => {
      if (tab.value === 'master-schedule') {
        if (classroom && classroom.classType === 'timetable') {
          result.push(tab);
        }
      } else {
        result.push(tab);
      }

      return result;
    }, []);

    return (
      <Menu onClick={this.onChangeFocusTab} selectedKeys={[this.state.selectedTab]} mode="horizontal">
        {renderTabs.map((tab) => (
          <Menu.Item key={tab.value} className={classes.menuItem}>
            <div>{tab.label}</div>
          </Menu.Item>
        ))}
      </Menu>
    );
  }

  getReviewClass = async (query) => {
    const classId = this.props.params.classId;
    const reviews = await getReviewClass(classId, { limit: 20, ...query });
    this.setState({ reviews });
    window.scroll(0, 0);
  };

  render() {
    // console.log(this.state.files);
    const loading = this.state.loading;

    const classroom = this.state.classroom;
    console.log(this.state);
    if (!classroom) {
      return <div></div>;
    }
    console.log(this.state.reviews);
    const selectedTab = this.state.selectedTab;
    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <div className="page-header">
            {this.props.BreadCrumb}
            <ClassHeader classroom={classroom} Tabs={this.renderTabs()} onOpenCloseModal={this.showCloseConfirm} getClassById={this.reloadClass} />
          </div>
          {selectedTab === 'info' && (
            <ClassInfoTab
              {...this.state}
              getClassById={this.reloadClass}
              categories={this.state.categories || []}
              classroom={classroom}
              classRevisions={this.state.classRevisions}
              loading={this.state.loading}
              hideLoading={this.hideLoading}
              showLoading={this.showLoading}
            />
          )}
          {selectedTab === 'schedules' && <ClassSchedules {...this.state} classroom={this.state.classroom} />}
          {selectedTab === 'reviews' && (
            <ClassReviewsTab
              getReviewClass={this.getReviewClass}
              _reviews={this.state.reviews}
              reviews={_.get(this.state, 'reviews.results')}
              page={_.get(this.state, 'reviews.page') || 1}
              count={_.get(this.state, 'reviews.count')}
              classroom={this.state.classroom}
            />
          )}
          {selectedTab === 'master-schedule' && (
            <MasterScheduleTab
              {...this.state}
              getClassById={this.reloadClass}
              categories={this.state.categories || []}
              classroom={classroom}
              provinces={this.state.provinces}
              districts={this.state.districts}
              loading={this.state.loading}
              hideLoading={this.hideLoading}
              showLoading={this.showLoading}
            />
          )}
        </Spin>
      </div>
    );
    //   schedules: PropTypes.array.isRequired,
    //   schedulesLoading: PropTypes.bool,
    //   page: PropTypes.number,
    //   classCount: PropTypes.number,
    //   serviceFeeLevel: PropTypes.array,
    //   classroom: PropTypes.any,
    //   // form: PropTypes.Any,
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
  }),
  {},
)(ClassInfo);
